import React, { useRef, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    DocumentEditorContainerComponent,
    Toolbar
} from '@syncfusion/ej2-react-documenteditor';
import { registerLicense } from '@syncfusion/ej2-base';
import OuraNav from "../components/OuraNav";
import fetchBase from "../utils/fetchBase";

DocumentEditorContainerComponent.Inject(Toolbar);

export default function HubWordViewerPage() {
    const { hubId, sectionId, documentId } = useParams();
    const navigate = useNavigate();
    const editorRef = useRef(null);
    const token = localStorage.getItem("jwt_token");

    useEffect(() => {
        const loadDocument = async () => {
            try {
                const res = await fetch(`${fetchBase}/api/document-hub/documents/${documentId}/file`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                const blob = await res.blob();
                const file = new File([blob], "document.docx", {
                    type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                });
                if (editorRef.current) {
                    editorRef.current.documentEditor.open(file);
                }
            } catch (err) {
                console.error("Failed to load Word document:", err);
            }
        };
        loadDocument();
    }, [documentId]);

    const handleDownload = () => {
        if (editorRef.current) {
            editorRef.current.documentEditor.save("document", "Docx");
        }
    };

    return (
        <div style={{ backgroundColor: "#f2f2f7", minHeight: "100vh" }}>
            <OuraNav links={[
                { label: "Dashboard", href: "/admin-dashboard" },
                { label: "Employees", href: "/employees" },
                { label: "Clients", href: "/admin/clients" },
                { label: "Scheduler", href: "/scheduler" },
                { label: "Payroll", href: "/admin/payroll" }
            ]} />

            <div style={{ maxWidth: 1200, margin: "0 auto", padding: "40px 40px" }}>
                <div style={{ fontSize: "13px", color: "#6e6e73", marginBottom: "24px", display: "flex", alignItems: "center", gap: "6px" }}>
                    <span onClick={() => navigate("/document-hub")} style={{ cursor: "pointer", color: "#0071e3", fontWeight: "500" }}>Document Hub</span>
                    <span>›</span>
                    <span onClick={() => navigate(`/document-hub/${hubId}`)} style={{ cursor: "pointer", color: "#0071e3", fontWeight: "500" }}>Hub</span>
                    <span>›</span>
                    <span onClick={() => navigate(`/document-hub/${hubId}/sections/${sectionId}`)} style={{ cursor: "pointer", color: "#0071e3", fontWeight: "500" }}>Section</span>
                    <span>›</span>
                    <span style={{ color: "#1d1d1f", fontWeight: "500" }}>Document</span>
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "16px" }}>
                    <button
                        onClick={handleDownload}
                        style={{ padding: "9px 20px", backgroundColor: "#1d1d1f", color: "#fff", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}
                    >
                        Download Word
                    </button>
                </div>

                <div style={{ height: "85vh", borderRadius: "12px", overflow: "hidden", boxShadow: "0 2px 12px rgba(0,0,0,0.1)" }}>
                    <DocumentEditorContainerComponent
                        ref={editorRef}
                        id="hub-word-editor"
                        height="100%"
                        enableToolbar={true}
                        showPropertiesPane={false}
                        serviceUrl=""
                    />
                </div>
            </div>
        </div>
    );
}